import { ActorType } from '@qdrant/qdrant-cloud-public-api/common/v1';

/** Shown when a key has no user behind it: created by the system, or before creators were recorded. */
export const UNKNOWN_KEY_CREATOR = 'unknown';

/**
 * Describes who a management key or database API key is attributed to.
 *
 * A key created by another key inherits the attribution of that key, so the address alone would
 * suggest the person created it themselves. The actor type keeps that distinction visible.
 */
export function formatKeyCreator(createdByEmail: string, createdByActorType: ActorType): string {
  if (!createdByEmail) {
    return UNKNOWN_KEY_CREATOR;
  }
  if (createdByActorType === ActorType.MANAGEMENT_KEY) {
    return `${createdByEmail} (via API key)`;
  }
  return createdByEmail;
}
